angular.module('dpw.services').factory('manageRoleAndAppAccessService', ['$rootScope', '$q', '$window', 'api', 'popup', 'popupUtil', 'dpwAppAccessService', 'dpwUserRoleService', function ($rootScope, $q, $window, api, popup, popupUtil, dpwAppAccessService, dpwUserRoleService) {
    return {
        showDialog: showDialog,
        fetchRolePermission: fetchRolePermission,
        shouldDisplayAppAccessSettings: shouldDisplayAppAccessSettings
    };

    function showDialog(developerId) {
        var deferred = $q.defer();
        var newScope = $rootScope.$new();

        newScope.rolePermissionConfig = {
            developerId: developerId,
            showHeader: true,
            extraClass: 'manage-role-and-app-access-standalone-window',
            onClose: function () {
                newScope.$destroy();
            },
            onSubmit: function (data) {
                updateRolePermission(payloadGenerator(data))
                    .then(function () {
                        newScope.$destroy();

                        popupUtil.ok({
                            title: RCDPW.Lang.CONGRATULATIONS,
                            content: RCDPW.Lang.MyAccount.RolePermission.UPDATE_CONFIG_SUCCESSFULLY,
                            callback: function () {
                                deferred.resolve();
                                $window.location.reload();
                            }
                        });
                    })
                    .catch(function (data) {
                        var errorCode = _.get(data, 'err.status.message');
                        updateErrorDispatcher(errorCode, data.defaultErrorHandler);
                    });
            }
        };

        popup({
            scope: newScope,
            directiveName: 'manage-role-and-app-access',
            showHeader: false,
            extraClass: 'my-account console-ui popup-auto-width'
        });

        return deferred.promise;
    }

    function payloadGenerator(data) {
        var appAccessChangeSets = {
            toWriteApps: [],
            toReadApps: []
        };

        if (shouldDisplayAppAccessSettings(data.userRole)) {
            _.forEach(data.appAccessSettings, function (appAccess, appId) {
                var originalAppAccess = data.originalAppAccessSettings[appId];

                if (!originalAppAccess || originalAppAccess !== appAccess) {
                    switch (appAccess) {
                        case dpwAppAccessService.AppAccess.ReadOnly:
                            appAccessChangeSets.toReadApps.push(appId);
                            break;
                        case dpwAppAccessService.AppAccess.ReadWrite:
                            appAccessChangeSets.toWriteApps.push(appId);
                            break;
                    }
                }
            });
        }

        return {
            id: data.developerId,
            role: data.userRole,
            toWriteApps: appAccessChangeSets.toWriteApps,
            toReadApps: appAccessChangeSets.toReadApps
        };
    }

    function fetchRolePermission(developerId) {
        return $q(function (resolve) {
            api.call(api.myAccount.developers.rolePermission.get({id: developerId}), function (data) {
                var unformattedAppAccessSettings = data.applications;

                resolve({
                    userRole: data.role,
                    appAccessSettings: unformattedAppAccessSettings.reduce(function (accumulated, item) {
                        accumulated[item.application.id] = hasWriteAccess(item.permissions) ?
                            dpwAppAccessService.AppAccess.ReadWrite :
                            dpwAppAccessService.AppAccess.ReadOnly;

                        return accumulated;
                    }, {})
                });
            });
        });

        function hasWriteAccess(permissions) {
            return _.includes(permissions, 'Edit');
        }
    }

    function updateRolePermission(payload) {
        return $q(function (resolve, reject) {
            api.call(api.myAccount.developers.rolePermission.update(payload), function () {
                resolve();
            }, function (err, defaultErrorHandler) {
                reject({
                    err: err,
                    defaultErrorHandler: defaultErrorHandler
                });
            });
        });
    }

    function updateErrorDispatcher(code, options) {
        var defaultErrorHandler = _.get(options, 'defaultErrorHandler', angular.noop);
        var handlers = {
            'AtLeastOneAdministrator': function () {
                popupUtil.ok({
                    content: RCDPW.Lang.MyAccount.RolePermission.ERROR_AT_LEAST_ONE_ADMIN
                });
            }
        };

        var handler = handlers[code] || defaultErrorHandler;
        handler();
    }

    function shouldDisplayAppAccessSettings(userRoleId) {
        if (!userRoleId) return false;

        var userRole = dpwUserRoleService.getUserRoleById(userRoleId);
        return userRole.showAppAccessSettings;
    }
}]);
